var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[
    `icon`,
    _vm.className,
    `mi-${_vm.size}px`,
    `mi-${_vm.name}`
  ],attrs:{"data-test":_vm.dataTest,"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }